module.exports = __webpack_public_path__ + "static/widget-img-3-84e00695473c0ac806e57cedce32dcf1.png";